// Filter field config for the new Today's Jobs table. The payload keys this
// page's endpoint actually accepts are driver_id, customer_code,
// invoice_number, job_id, delivery_status, shift_mode - kept separate from
// the old Orders page's orderFilterConfig.js (which uses different field
// names like "customer") so neither page can accidentally affect the other.
export const INITIAL_FILTER_STATE = {
  jobId: "",
  customerCode: "",
  invoiceNumber: "",
  driverId: "",
  status: "",
  shift: "",
};

// Empty operator ("") makes buildQueryParams send plain "apiField=value"
// instead of "filters[apiField][$op]=value" - this endpoint expects flat
// query params (e.g. invoice_number=N2727491), not the filters[] syntax.
export const fieldMappings = {
  jobId: ["job_id", ""],
  customerCode: ["customer_code", ""],
  invoiceNumber: ["invoice_number", ""],
  driverId: ["driver_id", ""],
  status: ["delivery_status", ""],
  shift: ["shift_mode", ""],
};

export const rangeFields = {};
export const valueTransformers = {};
